module.exports = __webpack_public_path__ + "static/media/doc-flat.6f6878d9.png";